import c2cOverviewVideo from '../assets/video/c2c_overview.mp4';

const guides = [
  {
    id: "shopify",
    name: "Shopify",
    logo: "/assets/images/manual/user-guide/shopify-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-Shopify.pdf",
    color: "#96bf48",
  },
  {
    id: "bigcommerce",
    name: "BigCommerce",
    logo: "/assets/images/manual/user-guide/bigcommerce-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-BigCommerce.pdf",
    color: "#34313f",
  },
  {
    id: "jimdo",
    name: "Jimdo",
    logo: "/assets/images/manual/user-guide/jimdo-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-Jimdo.pdf",
    color: "#ff6b35",
  },
  {
    id: "squarespace",
    name: "Squarespace",
    logo: "/assets/images/manual/user-guide/squarespace-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-SQUARESPACE.pdf",
    color: "#222222",
  },
  {
    id: "wix",
    name: "Wix",
    logo: "/assets/images/manual/user-guide/wix-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-Wix.pdf",
    color: "#faad00",
  },
  {
    id: "weebly",
    name: "Weebly",
    logo: "/assets/images/manual/user-guide/weebly-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-Weebly.pdf",
    color: "#1a9ce0",
  },
  {
    id: "woocommerce",
    name: "WooCommerce",
    logo: "/assets/images/manual/user-guide/woocommerce-logo.jpg",
    pdf: "https://app.contexttocall.com/assets/images/manual/user-guide/C2C-UserGuide-Woocommerce.pdf",
    color: "#7f54b3",
  },
];

const styles = {
  page: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "var(--text-primary)",
    backgroundColor: "var(--bg-primary)",
    overflowX: "hidden",
  },
  hero: {
    background: "linear-gradient(135deg, #0f3460 0%, #16213e 60%, #0d7377 100%)",
    color: "#fff",
    textAlign: "center",
    padding: "80px 20px 60px",
  },
  heroSubtitle: {
    fontSize: "13px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "#14e3e3",
    marginBottom: "12px",
    margin: "0 0 12px",
  },
  heroTitle: {
    fontSize: "clamp(36px, 6vw, 64px)",
    fontWeight: "800",
    lineHeight: 1.1,
    margin: "0 0 20px",
  },
  heroDesc: {
    fontSize: "17px",
    opacity: 0.8,
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: 1.7,
  },
  section: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "72px 24px",
  },
  sectionLabel: {
    fontSize: "12px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "var(--cyan-400)",
    fontWeight: "700",
    marginBottom: "8px",
  },
  sectionTitle: {
    fontSize: "clamp(26px, 4vw, 40px)",
    fontWeight: "800",
    marginBottom: "40px",
    color: "var(--text-primary)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: "24px",
  },
  card: {
    background: "var(--surface)",
    borderRadius: "16px",
    padding: "28px 24px",
    boxShadow: "var(--shadow-sm)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    border: "2px solid var(--site-border)",
    transition: "box-shadow 0.2s, transform 0.2s",
  },
  logoContainer: {
    width: "120px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    maxWidth: "120px",
    maxHeight: "60px",
    objectFit: "contain",
  },
  platformName: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-primary)",
  },
  downloadBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 22px",
    borderRadius: "30px",
    background: "linear-gradient(135deg, #0f3460, #0d7377)",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    textDecoration: "none",
    transition: "opacity 0.2s",
    cursor: "pointer",
  },
  videoSection: {
    background: "linear-gradient(135deg, #0f3460, #0d7377)",
    color: "#fff",
    textAlign: "center",
    padding: "72px 24px",
  },
  videoWrapper: {
    maxWidth: "780px",
    margin: "36px auto 0",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    position: "relative",
    background: "#000",
  },
  video: {
    width: "100%",
    display: "block",
    borderRadius: "16px",
  },
};

export default function UserGuidePage() {
  return (
    <div style={styles.page}>
      {/* Hero */}
      <section style={styles.hero}>
        <p style={styles.heroSubtitle}>User Guide</p>
        <h1 style={styles.heroTitle}>
          Step-by-Step{" "}
          <span style={{ color: "#14e3e3" }}>Manual</span>
        </h1>
        <p style={styles.heroDesc}>
          Download the user guides below to follow a step-by-step process for
          adding Context to Call on these popular platforms.
        </p>
      </section>

      {/* Platform Guides Grid */}
      <div style={styles.section}>
        <p style={styles.sectionLabel}>Guides</p>
        <h2 style={styles.sectionTitle}>Choose Your Platform</h2>

        <div style={styles.grid}>
          {guides.map((guide) => (
            <div
              key={guide.id}
              style={styles.card}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "var(--shadow-lg)";
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow =
                  "var(--shadow-sm)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div style={styles.logoContainer}>
                <img
                  src={guide.logo}
                  alt={guide.name}
                  style={styles.logo}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
                <span
                  style={{
                    display: "none",
                    fontSize: "22px",
                    fontWeight: "800",
                    color: guide.color,
                  }}
                >
                  {guide.name}
                </span>
              </div>

              <span style={styles.platformName}>{guide.name}</span>

              <a
                href={guide.pdf}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.downloadBtn}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                ⬇ Download
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Video Overview Section */}
      <section style={styles.videoSection}>
        <p style={{ ...styles.sectionLabel, color: "#14e3e3" }}>Overview</p>
        <h2
          style={{
            fontSize: "clamp(26px, 4vw, 40px)",
            fontWeight: "800",
            color: "#fff",
            margin: "0",
          }}
        >
          Watch a Quick Overview
        </h2>
        <p
          style={{
            marginTop: "12px",
            opacity: 0.75,
            fontSize: "16px",
            maxWidth: "500px",
            margin: "12px auto 0",
          }}
        >
          See Context to Call in action before diving into the detailed guides.
        </p>

        <div style={styles.videoWrapper}>
          <video
            style={styles.video}
            controls
            poster="/sites/default/files/video/c2c-video-thumbnail.png"
          >
            <source
              src={c2cOverviewVideo}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
    </div>
  );
}
